import { el } from '../utils/dom.js';

export function field({ name, label, type = 'text', value, options, hint, required, full, ...rest }) {
  const id = `f_${name}_${Math.random().toString(36).slice(2, 7)}`;
  const cls = `field ${full ? 'full' : ''}`;
  const labelEl = el('label', { for: id }, label || name);

  let control;
  if (type === 'select') {
    control = el('select', { id, name, class: 'select', required, ...rest });
    if (!required) control.appendChild(el('option', { value: '' }, '—'));
    for (const opt of options || []) {
      const o = el('option', { value: opt.value }, opt.label || opt.value);
      if (String(opt.value) === String(value)) o.selected = true;
      control.appendChild(o);
    }
  } else if (type === 'textarea') {
    control = el('textarea', { id, name, class: 'textarea', required, ...rest }, value || '');
  } else if (type === 'checkbox') {
    return el('label', { class: 'checkbox', for: id },
      el('input', { id, name, type: 'checkbox', checked: !!value, ...rest }),
      el('span', {}, label)
    );
  } else {
    control = el('input', { id, name, type, value: value ?? '', class: 'input', required, ...rest });
  }

  return el('div', { class: cls },
    labelEl,
    control,
    hint ? el('div', { class: 'hint' }, hint) : null,
  );
}

export function readForm(formEl) {
  const fd = new FormData(formEl);
  const obj = {};
  for (const [k, v] of fd.entries()) {
    if (v === '') continue;
    if (k in obj) {
      if (!Array.isArray(obj[k])) obj[k] = [obj[k]];
      obj[k].push(v);
    } else {
      obj[k] = v;
    }
  }
  // Handle unchecked checkboxes (FormData omits them)
  for (const cb of formEl.querySelectorAll('input[type=checkbox]')) {
    if (!(cb.name in obj)) obj[cb.name] = false;
    else obj[cb.name] = true;
  }
  return obj;
}
